import { SVGProps } from "react";

const CancelIcon = ({
    width = 18,
    height = 18,
    onClick = () => {},
    className,
    ...props
}: {
    width: number;
    height: number;
    onClick: () => void;
    className?: string;
    props: SVGProps<SVGSVGElement>;
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            onClick={onClick}
            className={className}
            viewBox="0 0 18 18"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.368.368a1.25 1.25 0 0 1 1.768 0L9 7.232 15.864.368a1.25 1.25 0 0 1 1.768 1.768L10.768 9l6.864 6.864a1.25 1.25 0 1 1-1.768 1.768L9 10.768l-6.864 6.864a1.25 1.25 0 0 1-1.768-1.768L7.232 9 .368 2.136a1.25 1.25 0 0 1 0-1.768Z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CancelIcon;
